<template>
  <v-flex>
    <vue-markdown
      class="mb-4 px-2"
      :html="true"
      v-if="getTemplateByName('SECOND_STEP_HEADER_CONTENT') != null"
    >{{getTemplateByName("SECOND_STEP_HEADER_CONTENT").content}}</vue-markdown>

    <v-form v-model="ticketsFillValid">
      <Ticket
        v-for="(ticket, ticketIndex) in ticketsClone"
        :key="ticketIndex"
        v-model="ticketsFillValid"
        :ticket="ticket"
        :ticketIndex="ticketIndex"
        :last="ticketIndex == (ticketsClone.length - 1) ? true : false"
      />
    </v-form>
    <v-layout row v-if="$vuetify.breakpoint.mdAndUp">
      <div data-aos="fade-left" data-aos-offset="30">
        <v-btn class="ma-3" @click.native="handleBackButton()">
          <v-icon left>navigate_before</v-icon>Back
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <div data-aos="fade-right" data-aos-offset="30">
        <v-btn
          class="ma-3"
          color="primary"
          :disabled="!ticketsFillValid"
          @click.native="handleCompanyInput();"
        >
          Continue as legal entity
          <v-icon right>navigate_next</v-icon>
        </v-btn>
      </div>
      <div data-aos="fade-right" data-aos-offset="30">
        <v-btn
          class="ma-3 white--text"
          color="red"
          :disabled="!ticketsFillValid"
          @click.native="handleIndividualInput();"
        >
          Continue as individual
          <v-icon right>navigate_next</v-icon>
        </v-btn>
      </div>
    </v-layout>

    <template v-if="$vuetify.breakpoint.smAndDown">
      <div data-aos="fade-right" data-aos-offset="30">
        <div class="text-center">
          <v-btn
            class="my-3"
            color="primary"
            :disabled="!ticketsFillValid"
            @click.native="handleCompanyInput();"
          >
            Continue as legal entity
            <v-icon right>navigate_next</v-icon>
          </v-btn>
        </div>

        <div class="text-center">
          <v-btn
            class="my-3 white--text"
            color="red"
            :disabled="!ticketsFillValid"
            @click.native="handleIndividualInput();"
          >
            Continue as individual
            <v-icon right>navigate_next</v-icon>
          </v-btn>
        </div>
      </div>
      <div data-aos="fade-left" data-aos-offset="20">
        <v-btn class="my-3" @click.native="handleBackButton();">
          <v-icon left>navigate_before</v-icon>Back
        </v-btn>
      </div>
    </template>
  </v-flex>
</template>

<script>
import VueMarkdown from "vue-markdown";
import helperMethods from "../mixins/helperMethods";
import paymentOptions from "../mixins/paymentOptions";
import Ticket from "@/components/Ticket";
import storeData from "../mixins/storeData";

export default {
  components: {
    VueMarkdown,
    Ticket
  },
  props: {},
  data() {
    return {
      ticketsFillValid: false,
      ticketsClone: null
    };
  },
  mixins: [storeData, helperMethods, paymentOptions],
  methods: {
    orderKlix() {
      this.$emit("change", {
        orderKlix: true
      });
    },
    updateFromClones() {
      this.tickets = this.ticketsClone;
    },
    handleIndividualInput() {
      this.updateFromClones();
      this.isCompany = false;
      if (this.paymentCardIsShown()) {
        this.orderKlix();
        this.widgetShow = true;
      }
      this.$gtm.trackEvent({
        category: "attendees-individual-continue-button",
        action: "click",
        noninteraction: false
      });
      this.scrollToTop();
      this.currentStep = 3;
    },
    handleCompanyInput() {
      this.updateFromClones();
      this.isCompany = true;
      this.$gtm.trackEvent({
        category: "attendees-company-continue-button",
        action: "click",
        noninteraction: false
      });
      this.scrollToTop();
      this.currentStep = 3;
    },
    handleBackButton() {
      this.updateFromClones();
      this.scrollToTop();
      this.currentStep = 1;
    }
  },
  beforeMount() {
    this.ticketsClone = _.cloneDeep(this.tickets);
  }
};
</script>